const DodgeEvent = function( battleState, actor ) {
	this.eventHandle = 'dodge';
	this.actorId = actor.uid;
	
	this.execute = () => {
		battleState.onBattleEvent( this );	
	};
};
module.exports = DodgeEvent
